import { render, staticRenderFns } from "./sale-scenario.vue?vue&type=template&id=2b12e653&scoped=true&"
import script from "./sale-scenario.vue?vue&type=script&lang=js&"
export * from "./sale-scenario.vue?vue&type=script&lang=js&"
import style0 from "./sale-scenario.vue?vue&type=style&index=0&id=2b12e653&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b12e653",
  null
  
)

export default component.exports